import { ReportsService } from "src/app/reports/reports.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Component, OnInit } from "@angular/core";

declare var $: any;

@Component({
    selector: "app-public-result",
    templateUrl: "./public-result.component.html",
    styleUrls: ["./public-result.component.scss"],
})
export class PublicResultComponent implements OnInit {
    public fixture: any = null;
    public isTab1 = false;
    public isTab2 = false;
    public isTab3 = false;
    public isTab4 = false;
    public isTab5 = false;
    public isTab6 = false;
    public isTab7 = false;
    public isTab8 = false;
    public isTab9 = false;
    public isTab10 = false;

    constructor(
        private spinner: NgxSpinnerService,
        private reportsService: ReportsService
    ) {
        this.spinner.show();
        document.querySelector("body").classList.add("public-content");
        const currentDate = new Date();
        const currentDay = currentDate.getDate();
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear();
        const today = `${currentYear}-${currentMonth}-${currentDay}`;
        this.getByDate(today, true);
    }

    ngOnInit() {}

    hideTab() {
        this.isTab1 = false;
        this.isTab2 = false;
        this.isTab3 = false;
        this.isTab4 = false;
        this.isTab5 = false;
        this.isTab6 = false;
        this.isTab7 = false;
        this.isTab8 = false;
        this.isTab9 = false;
        this.isTab10 = false;
    }

    showTab(date: string) {
        switch (date) {
            case "2025-1-16": {
                this.isTab1 = true;
                break;
            }
            case "2025-1-17": {
                this.isTab2 = true;
                break;
            }
            case "2025-1-18": {
                this.isTab3 = true;
                break;
            }
            case "2025-1-19": {
                this.isTab4 = true;
                break;
            }
            case "2025-1-20": {
                this.isTab5 = true;
                break;
            }
            case "2025-1-21": {
                this.isTab6 = true;
                break;
            }
            case "2025-1-22": {
                this.isTab7 = true;
                break;
            }
            case "2025-1-23": {
                this.isTab8 = true;
                break;
            }
            case "2025-1-24": {
                this.isTab9 = true;
                break;
            }
            case "2025-1-25": {
                this.isTab10 = true;
                break;
            }
        }
    }

    getByDate(date: string, isLanding = false) {
        this.spinner.show();
        this.hideTab();

        this.reportsService.getFixturePublicInGroup(date).subscribe((res) => {
            this.fixture = res.result;
            console.log(date);
            console.log(this.fixture);

            if (isLanding) {
                $(`[data-date="${date}"]`).tab("show");
            }

            this.showTab(date);

            setTimeout(() => {
                this.spinner.hide();
            }, 500);
        });
    }
}
